import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2)
  },
  pageButton: {
    minWidth: 36,
    height: 36,
    padding: 0,
    borderRadius: 6
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark
    }
  },
  ellipsis: {
    padding: theme.spacing(0, 1),
    color: theme.palette.text.secondary
  }
}));

// صفحه‌بندی ساده با دکمه‌های شماره صفحه، مطابق طرح ارسالی
export default function RequestsPagination({ page, totalPages, onPageChange }) {
  const classes = useStyles();

  // نمایش ۵ صفحه اول به همراه سه‌نقطه و آخرین صفحه، مشابه طرح
  const visiblePages = [1, 2, 3, 4, 5].filter((p) => p <= totalPages);

  return (
    <div className={classes.container}>
      <Button
        size="small"
        variant="outlined"
        className={classes.pageButton}
        disabled={page === 1}
        onClick={() => onPageChange(1)}
      >
        «
      </Button>
      <Button
        size="small"
        variant="outlined"
        className={classes.pageButton}
        disabled={page === 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
      >
        <ChevronRightIcon fontSize="small" />
      </Button>

      {visiblePages.map((p) => (
        <Button
          key={p}
          size="small"
          variant={p === page ? "contained" : "outlined"}
          className={`${classes.pageButton} ${p === page ? classes.active : ""}`}
          onClick={() => onPageChange(p)}
        >
          {p}
        </Button>
      ))}

      {totalPages > 5 && <span className={classes.ellipsis}>...</span>}

      {totalPages > 5 && (
        <Button
          size="small"
          variant={page === totalPages ? "contained" : "outlined"}
          className={`${classes.pageButton} ${
            page === totalPages ? classes.active : ""
          }`}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </Button>
      )}

      <Button
        size="small"
        variant="outlined"
        className={classes.pageButton}
        disabled={page === totalPages}
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
      >
        <ChevronLeftIcon fontSize="small" />
      </Button>
    </div>
  );
}
